(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/fade-in-slide-wrapper.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/fade-in-slide-wrapper.js');
'use strict';


function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const animate = refs => {
  const animations = refs.map(ref => {
    const tl = gsap.timeline({
      paused: true
    });
    tl.set(ref, {
      paddingTop: 10,
      opacity: 0
    });
    tl.to(ref, {
      opacity: 1,
      duration: 0.5,
      paddingTop: 0
    });
    tl.progress(0.00001);
    return tl;
  });
  animations.forEach((tl, index) => {
    if (index < animations.length - 1) {
      tl.eventCallback('onUpdate', function () {
        if (tl.progress() > 0.2 && !this.triggered) {
          animations[index + 1].play();
          this.triggered = true;
        }
      });
    }
  });
  setTimeout(() => {
    animations[0].play();
  }, 150);
};

const FadeInSlideWrapper = _ref => {
  let children = _ref.children;
  const childCount = React.Children.count(children);
  const refs = React.useRef(Array.from({
    length: childCount
  }, () => null));
  const _React$useState = React.useState(Array.from({
      length: childCount
    }, () => Math.random())),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    ids = _React$useState2[0];
  React.useLayoutEffect(() => {
    animate(refs.current);
  }, []);
  return React.createElement(React.Fragment, null, React.Children.map(children, (child, index) => React.createElement("div", {
    key: ids[index],
    ref: el => {
      refs.current[index] = el;
    }
  }, child)));
};
svs.playerRegistration.components.FadeInSlideWrapper = FadeInSlideWrapper;

 })(window);